module.exports = __webpack_public_path__ + "static/media/faq@2x.cc66a966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/faq@2x.png
// module id = 1784
// module chunks = 50